export const defaultFields = [
 {
  code: '',
  title: '',
  type: '',
  previousYears: 'Não',
  isRequired: 'Não',
  evidenceOnFile: 'Não',
  evidenceInImages: 'Não',
  hasAverage: 'Não',
  hasSum: 'Não',
  hasHelper: 'Não',
  helper: {
   description: '',
   url_video: '',
  },
  gridRows: [],
  gridColumns: [],
  // GRI-02: array vazio, não undefined — o multiselect é controlado e um
  // `value` indefinido o deixaria não-controlado no primeiro render.
  gri_ids: [],
 },
];

export const questionTypeOptions = [
 {
  value: 'multi_choice',
  label: 'Única opção',
 },
 { value: 'text', label: 'Dissertativa' },
 {
  value: 'multiple_choice',
  label: 'Múltipla escolha',
 },
 {
  value: 'grid',
  label: 'Grade/Matriz (Likert)',
 },
 {
  value: 'percentage',
  label: 'Porcentagem',
 },
 {
  value: 'number',
  label: 'Numérica',
 },
 {
  value: 'money',
  label: 'Monetária',
 },
];

export const alternativesTotalOptions = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
  { value: '14', label: '14' },
  { value: '15', label: '15' },
  { value: '16', label: '16' },
  { value: '17', label: '17' },
  { value: '18', label: '18' },
  { value: '19', label: '19' },
  { value: '20', label: '20' },
  { value: '21', label: '21' },
  { value: '22', label: '22' },
  { value: '23', label: '23' },
  { value: '24', label: '24' },
  { value: '25', label: '25' },
  { value: '26', label: '26' },
  { value: '27', label: '27' },
  { value: '28', label: '28' },
  { value: '29', label: '29' },
  { value: '30', label: '30' }
];


/**
 * EG-41: os campos que a classificação escreve.
 *
 * Eles gravam por PATCH, na hora, FORA do fluxo de versionamento — por isso
 * não contam como mudança de estrutura do template.
 */
export const CAMPOS_DE_CLASSIFICACAO = ['id_pillar', 'id_theme', 'gri_ids'];

/**
 * Decide se a edição de uma questão justifica uma versão nova do template.
 *
 * Só estrutura justifica: título, código, tipo, alternativas. Classificar não,
 * porque já foi persistido por conta própria. Sem esta distinção o botão
 * Finalizar acendia ao trocar apenas o tema, induzindo o gestor a gerar uma
 * versão sem motivo — e versionar soft-deleta a linhagem e recria TODAS as
 * questões com ids novos, que é justamente o que a EG-41 evita para não perder
 * o alvo da propagação.
 */
/**
 * Serializa de forma ESTÁVEL: chaves de objeto em ordem alfabética, recursivo.
 *
 * V4 — JSON.stringify puro preserva a ordem de inserção, então
 * { description, url_video } e { url_video, description } produzem strings
 * diferentes para o mesmo conteúdo. Os dois lados saem do mesmo builder hoje;
 * no dia em que um deles reordenar, o Finalizar volta a acender sem motivo.
 *
 * Arrays mantêm a ordem de propósito: reordenar alternativas é mudança real —
 * o gestor arrastou o card e a ordem chega ao respondente.
 */
const serializarEstavel = (valor) => {
  if (Array.isArray(valor)) {
    return `[${valor.map(serializarEstavel).join(',')}]`;
  }
  if (valor && typeof valor === 'object') {
    return `{${Object.keys(valor)
      .sort()
      .map((chave) => `${JSON.stringify(chave)}:${serializarEstavel(valor[chave])}`)
      .join(',')}}`;
  }
  return JSON.stringify(valor === undefined ? null : valor);
};

export const mudouEstrutura = (atual = {}, anterior = {}) =>
  Object.keys(atual).some((campo) => {
    if (CAMPOS_DE_CLASSIFICACAO.includes(campo)) return false;
    return serializarEstavel(atual[campo]) !== serializarEstavel(anterior[campo]);
  });

export const formatQuestionObject = ({
 code,
 type,
 previousYears,
 title,
 description,
 isRequired,
 requestFiles,
 requestImages,
 evidenceOnFile,
 evidenceInImages,
 hasHelper,
 hasSum,
 hasAverage,
 isCertified,
 helper = {},
 options = [],
 gridRows = [],
 gridColumns = [],
 id_question_template,
 id_pillar = null,
 id_theme = null,
 gri_ids = [],
}) => {
 const formattedQuestion = {
  code,
  question_type: type,
  previous_year: previousYears === 'Sim',
  description: title || description,
  is_required: isRequired === 'Sim',
  request_files: (requestFiles === 'Sim') || (evidenceOnFile === 'Sim'),
  request_images: (requestImages === 'Sim') || (evidenceInImages === 'Sim'),
  required_helper: hasHelper === 'Sim',
  has_sum: hasSum === 'Sim',
  has_average: hasAverage === 'Sim',
  isCertified: isCertified === 'Sim' && type === 'multiple_choice',
  helper: {
   description: helper.description || '',
   url_video: helper.url_video || '',
  },
  // EG-41 — CA01: a classificação vai junto no salvamento do template.
  //
  // Esta função desestrutura campo a campo, então o que não estiver listado
  // aqui é descartado em SILÊNCIO: o formulário coletava pilar e tema e o
  // payload os perdia, sem erro nenhum. Vale para os dois fluxos — template
  // novo e versionamento —, e no segundo é o que faz a versão nova nascer
  // classificada em vez de zerada.
  id_pillar,
  id_theme,
  // GRI-02: mesma armadilha do parágrafo acima — campo não listado aqui some
  // em silêncio. É por este caminho que a questão NOVA nasce com indicador, e
  // é o que faz a versão nova do template não nascer sem eles.
  gri_ids,
  ...(id_question_template && { id_question_template }),
 };

 // Para questões tipo grid
 if (type === 'grid') {
  formattedQuestion.options = gridColumns
   .filter((col) => col.description)
   .map((col, index) => ({
    description: col.description,
    language: 'pt-br',
    index,
    isIgnored: false,
    isPrerequisite: false,
   }));

  formattedQuestion.gridRows = gridRows
   .filter((row) => row.description)
   .map((row, index) => ({
    description: row.description,
    row_order: index,
   }));
 } else {
  // Para outros tipos de questão
  formattedQuestion.options = options.map(({ description, isPrerequisite }, index) => ({
   description,
   language: 'pt-br',
   index,
   isIgnored: isPrerequisite === 'Não',
   isPrerequisite: isPrerequisite === 'Sim',
  }));
 }

 return formattedQuestion;
};

